import { BreakpointObserver } from '@angular/cdk/layout';
import { AsyncPipe, NgOptimizedImage } from '@angular/common';
import { ChangeDetectionStrategy, Component, inject, Input } from '@angular/core';
import { map, Observable } from 'rxjs';
import { SanitizeHtmlPipe } from '../../pipes/sanitize-html.pipe';
import { ExecutiveMember } from './models/executive-member.type';
import { MemberOrderPipe } from './pipes/member-order.pipe';

@Component({
    selector: 'nw-executive-team-members-block',
    imports: [AsyncPipe, SanitizeHtmlPipe, MemberOrderPipe, AsyncPipe, NgOptimizedImage],
    templateUrl: './executive-team-members-block.component.html',
    styleUrl: './executive-team-members-block.component.scss',
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class ExecutiveTeamMembersBlockComponent {
    @Input() heading?: string = 'Executive Team';
    @Input() text?: string;
    @Input() members!: ExecutiveMember[];
    @Input() id?: string;

    private breakpointObserver: BreakpointObserver = inject(BreakpointObserver);

    public selectedIndex?: number;
    public focusIndex?: number;

    public gridSize$: Observable<2 | 4> = this.breakpointObserver
        .observe('(min-width: 768px)')
        .pipe(
            map(({ matches }) => !matches),
            map((matches) => (matches ? 2 : 4))
        );
}
